
	<div id="page-wrapper" [class.open]="isSidebarToggled">
	  <div id="sidebar-wrapper" >
		<ul *ngIf="!showMenu()" class="sidebar">
		  <li class="sidebar-main">
			<a (click)="toggleSidebar()" style="cursor: pointer;">
				District One Roster
				<span class="menu-icon glyphicon glyphicon-transfer"></span>
			  </a>
		  </li>
		</ul>
		<ul *ngIf="showMenu()" class="sidebar">
		  <li class="sidebar-main">
			<a (click)="toggleSidebar()" style="cursor: pointer;">
				District One Roster
				<span class="menu-icon glyphicon glyphicon-transfer"></span>
			  </a>
		  </li>
		  <li class="sidebar-title"><span>NAVIGATION</span></li>
		  <li class="sidebar-list">
			<a [routerLink]="[registrationsLink]">Registrations</a>
		  </li>
		  <li class="sidebar-list">
			<a [routerLink]="[sftpLink]">SFTP</a>
		  </li>
		  <li class="sidebar-list">
				<a target="_blank" href="https://vm.success.centegix.com/article/189-oneroster-app">Support <span *ngIf="isSidebarToggled == null ? false : !isSidebarToggled" class="menu-icon glyphicon glyphicon-question-sign" title="Support"></span></a>
			</li>
		</ul>
		<div class="sidebar-footer">
		  <div class="col-xs-8">
			<a href="https://centegix.com" target="_blank" [title]="appVersionTitle">
			   &copy; {{today | date:'y'}} centegix.com
			  </a>
		  </div>
		</div>
	  </div>
	  <div id="content-wrapper">
		<div class="page-content">
		  <div class="row header">
			<div class="col-xs-12">
			  <div class="user pull-right" style="min-width:0px;padding:11px 15px 15px 15px;">
			  <a *ngIf="isUsrNull" style="cursor:pointer; color:#919191; vertical-align: middle;" (click)="logout()">Logout</a>
				<div class="dropdown" [class.open]="isUserToggled" style="text-align:right;">
				  <a style="cursor:pointer; color:#919191;" class="dropdown-toggle" data-toggle="dropdown" (click)="toggleUser()" [offClick]="clickedOutside">
						{{userGreeting}}
				    </a>
				  <ul class="dropdown-menu dropdown-menu-right" role="menu">
						<li class="link">
							<a [href]="accLink">
								Account
							</a>
						</li>
						<li class="divider"></li>
						<li class="link">
							<a (click)="logout()">
							    Logout
							</a>
						</li>
				  </ul>
				</div>
				<div *ngIf="showMenu()"><span>{{schoolsName}}</span></div>
			  </div>
			  <div class="meta">
				<div class="page">
				  {{dashboardTitle}}
				</div>
				<div class="breadcrumb-links">
					<span *ngFor="let b of breadcrumbs">/ <a *ngIf="!b.noLink" href="{{b.link}}">{{b.title}}</a> <span *ngIf="b.noLink">{{b.title}}</span> </span>
				</div>
			  </div>
			</div>
		  </div>
			<app-reload [maxIdle]="appReloadMaxIdle" [forceTimeout]="appReloadForceTimeout" (onChange)="appReload($event)"></app-reload>
			<div *ngIf="msg.msg" class="row">
				<div class="col-lg-5 col-md-7 col-xs-12">
					<alert [alert]="msg"></alert>
				</div>
			</div>
		  <router-outlet (activate)="changeRoute()"></router-outlet>
		  <district-footer></district-footer>
		</div>
	  </div>
	</div>
  